import CallServer from '../../api/CallServerV2';
import FileServer from '../../api/FileServer'
import UploadServer from '../../api/UploadServer'
export async function fetchExams (params = {}) {
    return await CallServer({
        params: params,
        endpoint: '/admin/get_exams',
        isGet: true
    })
} 

export async function fetchExam (exam_id) {
    return await CallServer({
        params: {
            exam_id: exam_id
        },
        endpoint: '/admin/get_exam',
        isGet: true
    })
} 

export async function fetchUsersExam (exam_id, params = {}) {
    return await CallServer({
        params: {
            exam_id: exam_id,
            ...params
        },
        endpoint: '/admin/get_user_exams',
        isGet: true
    })
} 

export async function fetchGetFilteredUserExam (params = {}) {
    return await CallServer({
        params: {
            ...params
        },
        endpoint: '/admin/get_filtered_user_exams',
        isGet: true
    })
} 

export async function fetchCreateExam (exam_data) {
    return await CallServer({
        body  :exam_data,
        endpoint: '/admin/create_new_exam',
    })
} 

export async function fetchEditExam (exam_id,exam_data) {
    return await CallServer({
        params: {
            exam_id: exam_id
        },
        body  :exam_data,
        endpoint: '/admin/edit_exam',
    })
} 

export async function fetchAddQuestionsModules (exam_id,exam_data) {
    return await CallServer({
        params: {
            exam_id: exam_id
        },
        body:exam_data,
        endpoint: '/admin/add_new_questions_modules',
    })
} 

export async function fetchDownloadQuestions (exam_id) {
    return await FileServer({
        params: {
            exam_id: exam_id
        },
        isGet: true,
        endpoint: '/admin/download_questions_to_excel',
    })
} 

export async function fetchEditUserExam (user_exam_id,exam_data) {
    return await CallServer({
        params: {
            user_exam_id: user_exam_id
        },
        body:exam_data,
        endpoint: '/admin/edit_user_exam',
    })
} 

export async function fetchGenerateQuestion (exam_id, params = {}, file) {
    return await UploadServer({
        params: {
            exam_id: exam_id,
            ...params
        },
        body:file,
        endpoint: '/admin/generate_exam_questions',
    })
} 

export async function fetchRegenerateQuestion (generation_id, prompt) {
    return await UploadServer({
        params: {
            generation_id: generation_id,
            new_additional_instruction_prompt: prompt
        },
        endpoint: '/admin/retry_questions_generation',
    })
} 

export async function fetchAcceptGeneratedQuestion (generation_id) {
    return await UploadServer({
        params: {
            generation_id: generation_id
        },
        endpoint: '/admin/accept_generated_questions',
    })
} 

export async function fetchRejectGeneratedQuestion (generation_id) {
    return await UploadServer({
        params: {
            generation_id: generation_id
        },
        endpoint: '/admin/reject_generated_questions',
    })
}

export async function fetchExamScoreboard (exam_id, params = {}) {
    return await CallServer({
        params: {
            exam_id: exam_id,
            ...params
        },
        endpoint: '/admin/get_exam_scoreboard'
    })
} 

export async function fetchUserExam (user_exam_id, params = {}) {
    return await CallServer({
        isGet: true,
        params: {
            user_exam_id: user_exam_id,
            ...params
        },
        endpoint: '/admin/get_user_exam'
    })
} 

export async function fetchAcceptUserExam (user_exam_id, message = null) {
    return await CallServer({
        params: {
            user_exam_id: user_exam_id,
            ...(message && {
                accepted_message: message
            })
        },
        endpoint: '/admin/accept_user_exam_proctor',
    })
} 

export async function fetchRejectUserExam (user_exam_id, message = null) {
    return await CallServer({
        params: {
            user_exam_id: user_exam_id,
            ...(message && {
                rejected_message: message
            })
        },
        endpoint: '/admin/reject_user_exam_proctor',
    })
} 

export async function fetchAddUserExamNote (user_exam_id, message = null) {
    return await CallServer({
        params: {
            user_exam_id: user_exam_id,
            ...(message && {
                admin_note: message
            })
        },
        endpoint: '/admin/add_admin_note_to_user_exam',
    })
} 

export async function searchExams (params = {}) {
    return await CallServer({
        params: params,
        endpoint: '/admin/search_exams',
    })
} 